import api from './api';
import { LoginResponse } from '../types';

export const login = async (email: string, password: string) => {
  console.info('[auth] login attempt', {
    email,
    passwordLength: password.length,
  });

  try {
    const response = await api.post<LoginResponse>('/auth/login', { email, password });
    console.info('[auth] login success', {
      status: response.status,
      hasAccessToken: Boolean(response.data?.accessToken),
      hasRefreshToken: Boolean(response.data?.refreshToken),
    });
    return response;
  } catch (error) {
    console.error('[auth] login failed', error);
    throw error;
  }
};

export const logout = () => api.post('/auth/logout');
